import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape} from 'react-intl';
import cx from 'classnames';
import { buildJournalItemUrl } from 'shared/helpers/urlBuilder';
import NewsItem, { TYPES } from 'shared/components/NewsItem/NewsItem';
import sqListImg from 'shared/assets/images/two-rows-sq-list.svg';
import lineListImg from 'shared/assets/images/two-rows-line-list.svg';
import { getTitleOrEmpty } from 'shared/helpers/common';
import s from './NewsList.css';

const typesToClassNames = {
  [TYPES.TABLE]: s.tableItem,
};

class NewsList extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    tag: PropTypes.string,
    shortView: PropTypes.bool,
    currentRubric: PropTypes.shape(),
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    videoTopics: [],
    videoOrderBy: '',
    tag: null,
    shortView: false,
    currentRubric: null,
  };

  state = {
    currentType: TYPES.TABLE,
  };

  handleSetTypeClick = type => {
    this.setState({ currentType: type });
  };

  render() {
    const { news, tag, currentRubric, shortView, intl } = this.props;
    const currentType = shortView ? TYPES.LIST : this.state.currentType;

    return (
      <div className={s.root}>
        {!shortView && (
          <div className={s.header}>
            <div className={s.title}>
              <h1>{intl.formatMessage({ id: getTitleOrEmpty(currentRubric) || 'Новости' })}</h1>
            </div>
            <div>
              {Object.values(TYPES).map(type => (
                <button
                  key={type}
                  className={s.headerButton}
                  onClick={() => this.handleSetTypeClick(type)}
                  disabled={type === currentType}
                >
                  {type === TYPES.TABLE && <img src={sqListImg} width="20" alt="" />}
                  {type === TYPES.LIST && <img src={lineListImg} width="20" alt="" />}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className={cx({ [s.table]: currentType === TYPES.TABLE })}>
          {news.length !== 0 ? (
            news.map(item => (
              <NewsItem
                key={item.id}
                {...item}
                className={typesToClassNames[currentType]}
                type={currentType}
                link={buildJournalItemUrl(item.slug, tag)}
              />
            ))
          ) : (
            <div className={s.emptyBlock}>
              <FormattedMessage id={'По Вашему запросу ничего не найдено'} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(NewsList));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/components/NewsList/NewsList.js